// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Details_componentWrapper__SPyBZ","price":"Details_price__2F1eV","title":"Details_title__RfmTg","label":"Details_label__baUdg"};